import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { 
    faCamera,
    faSitemap,
    faShoppingCart,
    faShippingFast,
    faDonate,
    faAddressBook,
    faDatabase,
    faCube,
    faCog,
    faLuggageCart,
    faCarSide,
    faMoneyCheckAlt,
    faUser,
    faEllipsisH,
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faBackward,
    faQuestionCircle,
    faSortDown,
    faPlay

    
} from '@fortawesome/free-solid-svg-icons'

library.add(
    faCamera,
    faSitemap,
    faShoppingCart,
    faShippingFast,
    faDonate,
    faAddressBook,
    faDatabase,
    faCube,
    faCog,
    faLuggageCart,
    faCarSide,
    faMoneyCheckAlt,
    faUser,
    faEllipsisH,
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faBackward,
    faQuestionCircle,
    faSortDown,
    faPlay

)

Vue.component('font-awesome-icon', FontAwesomeIcon)




// WEBPACK FOOTER //
// ./src/icons/index.js